import React from "react";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid2";

const Bannershimmer = () => {
  return (
    <div class="card-shimmer loading" style={{ height:"100vh"}}>
      <div class="image" style={{height:"100vh"}}></div>
    </div>
  );
};

export default Bannershimmer;
